// Gatsby requirements
import React, { useState } from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'
import SeoStructuredData from './seoStructuredData'
import Button from 'utils/linkLogic';

// Styles
import * as CSS from './sectionAdList.module.scss'

const SectionAdList = ({ blok }) => {

    // Logic for opening more ads
    const [openMore, setOpenMore] = useState(false)

    return (
        <section 
            className={`${CSS.section} ${blok.style}`}
            id={blok.anchorId}
            style={{
                backgroundColor: blok.backgroundColor,
                paddingTop: blok?.removeTopMargin ? '0.5rem' : null,
                paddingBottom: blok?.removeBottomMargin ? '0.5rem' : null
            }}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">

                {blok.richtext !== "" && blok.richtext &&
                    <div className={CSS.richtext}>
                        <RichTextRenderer data={blok.richtext} />
                    </div>
                }

                <ol className={`${openMore === true ? CSS.showMore : ''} ${CSS.adlist}`}>
                    {blok.ads.map((loop, index) => ( <>
                        {loop.structuredData && 
                            <SeoStructuredData data={loop.structuredData} />
                        }
                        <li 
                            className={CSS.card}
                            style={{
                                backgroundColor: blok.backgroundColor === '#f1f1ef' ? '#fff' : '#f1f1ef',
                                display: index < blok.loadMoreAmount ? '' : 'none'
                            }}>

                            <span aria-hidden="true" className={CSS.number}>{index + 1}</span>

                            <div className={CSS.logoAndText}>
                                {loop.image.filename &&
                                    <div className={CSS.logoAndRatings}>
                                        <img
                                            src={loop.image.filename}
                                            loading="lazy"
                                            className={CSS.logo}
                                            width={loop?.image?.filename?.split('/')[5]?.split('x')[0]}
                                            height={loop?.image?.filename?.split('/')[5]?.split('x')[1]}
                                            alt={loop.image.alt}
                                        />
                                        {loop.rating &&
                                            <div className={CSS.rating}>
                                                <img
                                                    src="/icons/star-rating.svg"
                                                    className={`
                                                        ${CSS.starRating}
                                                        ${loop.rating > 8 && loop.rating <= 9 && CSS.rating45}
                                                        ${loop.rating > 7 && loop.rating <= 8 && CSS.rating4}
                                                        ${loop.rating > 6 && loop.rating <= 7 && CSS.rating35}
                                                        ${loop.rating > 5 && loop.rating <= 6 && CSS.rating3}
                                                        ${loop.rating > 4 && loop.rating <= 5 && CSS.rating25}
                                                        ${loop.rating > 3 && loop.rating <= 4 && CSS.rating2}
                                                        ${loop.rating > 2 && loop.rating <= 3 && CSS.rating15}
                                                        ${loop.rating <= 2 && CSS.rating1}
                                                    `}
                                                    loading="lazy"
                                                    width="106"
                                                    height="17"
                                                    alt={`Star rating: ${loop.rating.replace('.', ',')}`}
                                                />
                                                <span aria-hidden="true">{loop.rating.replace('.', ',')}</span>
                                            </div>
                                        }
                                    </div>
                                }

                                {loop.richtext &&
                                    <div className={CSS.firstText}>
                                        <RichTextRenderer data={loop.richtext} />
                                    </div>
                                }
                            </div>

                            {loop.secondRichtext &&
                                <div className={CSS.secondText}>
                                    <RichTextRenderer data={loop.secondRichtext} />
                                </div>
                            }
                        </li>
                    </> ))}
                </ol>
                
                {blok.ads.length > blok.loadMoreAmount &&
                    <button
                        className="button"
                        onClick={() =>
                            openMore === true
                            ? setOpenMore(false)
                            : setOpenMore(true)
                        }
                    >
                        {openMore === true ? 'Show less' : 'Show more'}
                    </button>
                }

                {blok.buttonAtBottom &&
                    <div className={CSS.buttons}>
                        {blok.buttonAtBottom.map((button, i) => (
                            <Button key={i} insertClass="button" data={button} />
                        ))}
                    </div>
                }

            </div>

        </section>
    )
}

export default SectionAdList